import Image from 'next/image';
import { useContext, useEffect, useState } from 'react';
import { ACTIONS, trackButtonClicked } from '@/utils/track';
import ClientContext from '@/contexts/client.context';
import SideModal from '@/components/platform/HeroWithCards/SideModal';
import { Button } from './styles';

const FloatingActionButton = ({ content }) => {
  const { client } = useContext(ClientContext);
  const { icon, conditionModal, solution } = content;
  const [showButton, setShowButton] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!showButton) return null;

  const handleButtonClick = () => {
    setModalIsOpen(!modalIsOpen);
    trackButtonClicked({
      action: ACTIONS.OPEN_DRAWER,
      buttonText: conditionModal?.buttonLabel,
      buttonLocation: 'floating button',
    });
  };

  const solutionConditionsData = solution
    ? [
        {
          solution: solution.data.attributes,
          solutionCondition: {
            product: solution.data.attributes.product,
            conditions: solution.data.attributes.conditions || [],
          },
        },
      ]
    : [];

  return (
    <>
      <Button id="floating-action-button" onClick={handleButtonClick}>
        {conditionModal?.buttonLabel}
        {icon && <Image width={32} height={32} src={icon?.data?.attributes?.url} />}
      </Button>
      {modalIsOpen && (
        <SideModal
          title={conditionModal?.title}
          subtitle={conditionModal?.subtitle}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          solutionConditions={solutionConditionsData}
          client={client}
          showSolutionHeader={false}
        />
      )}
    </>
  );
};

export default FloatingActionButton;
